<div class="custom-questions-preview-container">
  <div class="preview-header">
    <span class="preview-title">{{ 'bikeshop.modal.update_job_card.tab.custom_questions' | translate }}</span>
  </div>
  
  <div class="preview-content" *ngIf="getQuestionsWithResponses().length > 0">
    <div *ngFor="let group of getQuestionsWithResponses()" class="service-group">
      <div class="group-header">
        <span class="service-type">{{ group.groupName }} - {{ group.serviceType }}</span>
      </div>
      
      <div class="questions-list">
        <div *ngFor="let question of group.customQuestions" class="question-item">
          <div class="question-row">
            <div class="question-label">
              <daz-icon [name]="'user-question'" 
                        [size]="'14px'" [color]="'#6B728C'"></daz-icon>
              <span>{{ question.question }}</span>
            </div>
            <div class="question-response">
              {{ formatResponse(question) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="no-data-preview" *ngIf="getQuestionsWithResponses().length === 0">
    <span>{{ 'bikeshop.modal.update_job_card.custom_questions_preview.no_responses' | translate }}</span>
  </div>
</div>
